export async function queryCard() {}
